/* eslint-disable no-await-in-loop */
/**
 *
 * AddFiles
 *
 */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Button, Modal, ProgressBar } from 'react-bootstrap';
import config from 'config/index.js';
import Preview from 'components/media/Preview/index.jsx';
import ImageRestrictions from 'components/imageUse/ImageRestrictions/index.jsx';
import useStorage from 'utils/storage/useStorage.js';
import { mediaTypes } from 'utils/files.js';
import cx from 'utils/cx.js';
import SelectFiles from './SelectFiles/index.jsx';
import messages from './messages.js';
import useAddFiles, { MAX_PREVIEWS } from './useAddFiles.js';

export { default as splitFiles } from './splitFiles.js';

const Count = styled.span`
  display: inline-block;
  font-size: 80%;
  position: absolute;
  bottom: 5px;
  right: 5px;
`;

function AddFiles(props) {
  const { files = [], imagepreferences, types = mediaTypes.list, className = '', variant, onChange, disabled } = props;
  const [hideTip, setHideTip] = useStorage('hideImageUploadPreviewTip', false);
  useEffect(() => {
    if (config.env !== 'production') {
      setHideTip(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const { skipPreviews, setSkipPreviews, counts, progress, handleChange, handleDelete, handleAdd } = useAddFiles(files, onChange);

  return (
    <div className={cx('add-files', className)} disabled={disabled}>
      <Preview inline files={files} onChange={!disabled && handleChange} onDelete={!disabled && handleDelete} className="mb-3" />
      { progress > 0 && <ProgressBar now={progress} className="my-2" />}
      <div className="d-flex flex-wrap align-items-center">
        {types.map((tp) => (
          <SelectFiles key={tp} type={tp} multiple variant={variant} onChange={handleAdd} className="position-relative btn btn-link btn-round px-0" disabled={disabled}>
            <Count>{counts[tp] || ' '}</Count>
          </SelectFiles>
        ))}
        {imagepreferences && !imagepreferences.disabled && Object.keys(imagepreferences).some((key) => key.endsWith('Count') && imagepreferences[key] > 0)
          && <div className="flex-grow-1 text-end mb-2"><ImageRestrictions {...imagepreferences} link="communityposts/imagepreferences/details" /></div>}
      </div>
      <Modal show={skipPreviews && !hideTip} bsSize="small" onHide={() => setSkipPreviews(false)}>
        <Modal.Body>
          <p><FormattedMessage {...messages.skipPreviews} values={{ count: MAX_PREVIEWS }} /></p>
        </Modal.Body>
        <Modal.Footer className="text-end">
          <Button variant="primary" onClick={() => setHideTip(true)}><FormattedMessage {...messages.understand} /></Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

AddFiles.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string,
  files: PropTypes.array,
  imagepreferences: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  types: PropTypes.array,
  disabled: PropTypes.bool,
};

export default AddFiles;
